import { render, staticRenderFns } from "./ExclusionZone.layout.vue?vue&type=template&id=2058452e&scoped=true"
import script from "./ExclusionZone.layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExclusionZone.layout.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ExclusionZone.layout.vue?vue&type=style&index=0&id=2058452e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058452e",
  null
  
)

export default component.exports